module.exports = __webpack_public_path__ + "img/svg/clock.68e9dfee8b0610d6380b70b25e9dec38.svg";